/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router'
import { useSelector, useDispatch } from 'react-redux'
import { HealtheraButton, HeaderContainer, HeaderTitle, BackButton, BounceAnimatedContainer, Field } from '../../healtheraComponents'
import HealtheraTable from '../Table/Table'
import DynamicDialog from '../DynamicDialog/DynamicDialog'
import * as actions from '../../redux/commissions'

const MEDICATION_PRICE = 9

function BillingDetails(props) {

  const { commissions, charge } = useSelector(state => state.commissions)
  const { history } = props
  const orgID = props.match.params.ID
  const date = props.match.params.date
  const formattedDate = new Intl.DateTimeFormat('en-UK', { month: 'long', year: 'numeric' }).format(new Date(date))
  const [chargeOrgToggle, useChargeOrgToggle] = useState(false)
  const dispatch = useDispatch()
  const [manualAdjustment, setmanualAdjustment] = useState(0)
  const currentCommission = commissions ? commissions[date] : { charged: false }
  const disableButtonParams = (date === currentDate() || (currentCommission && currentCommission.charged))

  useEffect(() => {
    dispatch(actions.getCommissions(orgID))
  }, [dispatch, orgID])

  useEffect(() => {
    if (charge && charge.status) {
      window.alert(`This Organization charge is currently: ${charge.status}`)
    }
  }, [charge])

  const chargeCommission = () => {
    const { delivery: { items: deliveryItems, rate: deliveryRate } = {}, collect: { items: collectItems, rate: collectRate } = {} } = currentCommission
    const deliveryCommission = deliveryRate * deliveryItems
    const collectCommission = collectRate * collectItems
    let commission = deliveryCommission + collectCommission
    if (manualAdjustment) { commission = commission - parseFloat(manualAdjustment) }
    const unacceptablePayload = commission < 5
    const payload = { amount: commission, date, manualAdjustment }
    if (!unacceptablePayload && window.confirm(`You are about to charge this organization for ${formattedDate}, are you sure?`)) {
      dispatch(actions.chargeCommission(orgID, payload))
      dispatch(actions.getCommissions(orgID))
    } else {
      window.alert(`Charge did not go through ${unacceptablePayload ? `because the manual adjustment brought the charge to £${commission.toFixed(2)}, when it should not be lower then £5` : 'because you canceled'}, please try again`)
    }
    useChargeOrgToggle(false)
  }

  const goBack = () => {
    history.push(`${process.env.PUBLIC_URL}/organisations/${orgID}`)
  }

  const handleChange = name => event => {
    setmanualAdjustment(event.target.value)
  }

  const prepareData = () => {
    const { delivery: { orders: deliveryOrders, items: deliveryItems, rate: deliveryRate } = {}, collect: { orders: collectOrders, items: collectItems, rate: collectRate } = {}, manualAdjustment } = currentCommission
    const orders = deliveryOrders + collectOrders
    const items = deliveryItems + collectItems
    const deliveryCommission = deliveryRate * deliveryItems
    const collectCommission = collectRate * collectItems
    const commission = deliveryCommission + collectCommission
    const deliveryRev = deliveryItems * MEDICATION_PRICE
    const collectRev = collectItems * MEDICATION_PRICE
    const totalRev = deliveryRev + collectRev
    const totalCharge = commission - manualAdjustment
    const deliveryTable = ['Delivery', deliveryOrders, deliveryItems, deliveryRate, `£${deliveryCommission.toFixed(2)}`, `£${deliveryRev.toFixed(2)}`, '', '']
    const collectTable = ['Collect', collectOrders, collectItems, collectRate, `£${collectCommission.toFixed(2)}`, `£${collectRev.toFixed(2)}`, '', '']
    const totalTable = ['Total', orders, items, '', `£${commission.toFixed(2)}`, `£${totalRev.toFixed(2)}`, `£${-manualAdjustment.toFixed(2)}`, `£${totalCharge.toFixed(2)}`]
    const tableValues = [deliveryTable, collectTable, totalTable]
    return tableValues.reduce((array, card) => {
      array.push({ view: { ...card } })
      return array
    }, [{ ...header }])
  }

  return (
    <>
      <HeaderContainer padding={`20px 0 20px 0`} borderbottom={`none`} p={2} align='center'>
        <BackButton padding={`0 5px 0 0`} onClick={goBack} />
        <HeaderTitle cursor={`pointer`} onClick={goBack} px={2} w={1 / 3}>Back</HeaderTitle>
      </HeaderContainer>
      <h2> {formattedDate} </h2>
      <h3> Commissioned Items</h3>
      <BounceAnimatedContainer>
        {currentCommission && currentCommission.delivery && <HealtheraTable data={prepareData()} />}
        {!disableButtonParams && <HealtheraButton background={disableButtonParams ? '#bbbbbb' : '#2f9d6d'} disabled={disableButtonParams} onClick={() => useChargeOrgToggle(true)}>Charge Commission</HealtheraButton>}      </BounceAnimatedContainer>
      <DynamicDialog open={chargeOrgToggle} field={dialogField(manualAdjustment, handleChange)} title={'Charge Commission'} contentText={contentText(formattedDate, commissions)} actions={DialogButtons(() => useChargeOrgToggle(false), chargeCommission)} />
    </>
  )
}

export default withRouter(BillingDetails)

const header = { view: { 0: '', 1: 'Number of Orders', 2: 'Number of Items', 3: 'Commission per Item', 4: 'Total Commission Healthera', 5: 'Estimated Revenue (PSNC)', 6: 'Manual Adjustment', 7: 'Total Charge' }, headers: true }

const contentText = (date, commissions) => {
  const commissionsArr = [...Object.keys(commissions)].filter((value) => value !== 'defaultRate')

  const mapCommissions = (object) => {
    const { delivery: { rate: dRate }, collect: { rate: cRate } } = commissions[object]
    const formattedDate = new Intl.DateTimeFormat('en-UK', { month: 'long', year: 'numeric' }).format(new Date(object))
    return (<li>{formattedDate}: Delivery £ {dRate}, Collection £ {cRate}</li>)
  }

  return (
    <>
      <p>Clicking the Charge button will charge the current account
      for the month of {date}. If a Manual Adjustment is required
      , ensure that you have proper authorization to deduct the
      amount from the organization bill. Should you need to add to
      the bill don't forget to put a minus before your number.</p>
      {commissions && <div>
        <h4>Past Commissions</h4>
        {commissionsArr.map(x => mapCommissions(x))}
      </div>}
    </>
  )
}

const dialogField = (value, handleChange) => {
  return (<>
    <Field
      autoFocus
      id="manualAdjustment"
      type='number'
      label='Manual Adjustment'
      value={value.manualAdjustment}
      onChange={handleChange()} />
  </>)
}

const DialogButtons = (buttonOne, buttonTwo) => (
  <>
    <HealtheraButton onClick={buttonTwo} margin={'0 10px 5px'} height={'32px'} width={'95px'} color="primary">
      charge
    </HealtheraButton>
    <HealtheraButton onClick={buttonOne} margin={'0 10px 5px'} height={'32px'} background={'#d0021b'} width={'95px'} >
      cancel
    </HealtheraButton>
  </>
)

const currentDate = () => {
  let today = new Date()
  today.setDate(1)
  today = today.toISOString().slice(0, 10)
  return today
}
